import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  PipelineDetailsDto, LicenceStatusDto
} from "@cradua/data";

@Component({
  selector: 'cradua-pipeline-list',
  templateUrl: './pipeline-list.component.html',
  styleUrls: ['./pipeline-list.component.scss']
})
export class PipelineListComponent implements OnInit {
  @Input() pipelineDetails: PipelineDetailsDto[];

  @Input() searchPipelineDetails: PipelineDetailsDto[];
  @Input() licencestatuss: LicenceStatusDto[];
  @Output() emitEvent = new EventEmitter<any>();
  @Output() dispatchView = new EventEmitter<any>();
  isToggle = false;
  listView = false;
  gridView = true;

  constructor() {}

  ngOnInit() {
    if(this.pipelineDetails != null && this.pipelineDetails.length) {
      this.isToggle = true;
    }
  }


  protected findById = <T>(id: string) =>
    (fieldName: T) => fieldName["id"] === id;

    onList() {
      this.listView = true;
      this.gridView = false;
    }
  
    onGrid() {
      this.gridView = true;
      this.listView = false;
    }

    getLicenceStatusName(id: string) {
      return id
        ? this.licencestatuss.find(this.findById<LicenceStatusDto>(id))
          .LicenceStatusName
        : null;
    }

  onView(value) {
    this.dispatchView.emit(value);
  }
}
